import { useMemo } from "react";

export function detectStandalone() {
  return Boolean(
    ("standalone" in window.navigator && window.navigator.standalone) ||
      window.matchMedia("(display-mode: standalone)").matches,
  );
}

export default function useIsPwa() {
  const isPwa = useMemo(detectStandalone, []);

  return isPwa;
}
